import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.post({
      url: '/la/admin/feedback/list',
      data,
      dataType: 'form'
    });
  },
  setPass({ id }) {
    return http.post({
      url: `/la/admin/feedback/update?id=${id}`,

    });
  },
  exportExcel({ auditStatus, startTime, endTime }) {
    return http.get({
      url: `/la/admin/workorder/deposite_audit_List/excel?auditStatus=${auditStatus}&startTime=${startTime}&endTime=${endTime}`,
      responseType: 'blob',
    })
  },

  delete({ id }) {
    return http.post({
      url: `/la/admin/feedback/delete?id=${id}`,
    });
  },
};
